import React from 'react'
import i18n from 'i18next'
import k from '@/src/i18n/keys'
import { Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'

const moment = require('moment-business-days')

/** 零宽空格，用于productInfo中nextText freeTryOn的文字截断。获取到nextText后在需要截断的场景可以使用函数替换掉2个零宽字符中间的部分 */
const ZWSP = '\u200b'

/** 替换2个零宽空格之间的任意文字。用于处理零宽空格，替换productInfo中nextText包含freeTryOn的内容 */
const reviseNextText = (isFreeTryOn, nextText, replaceAll = false) => {
  var regex = new RegExp(`(${ZWSP}).*\\1`, (replaceAll && 'g') || '')
  if (!isFreeTryOn) {
    return nextText.replace(regex, '')
  }
  return nextText
}

const skuMap = {
  'Orka One': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_FULL_PRICE,
    monthly: process.env.NEXT_PUBLIC_PRODUCT_SKU_ORKA_ONE_INSTALLMENT
  },
  'Orka One Old': {
    full: process.env
      .NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_FULL_PRICE_PRICE1050,
    monthly: process.env.NEXT_PUBLIC_PRODUCT_SKU_ORKA_ONE_INSTALLMENT_PRICE1050
  },
  'Orka Insider Program Pay': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_INSIDER_PROGRAM_FULL_PRICE,
    monthly: process.env.NEXT_PUBLIC_PRODUCT_SKU_ORKA_ONE_INSTALLMENT
  },
  'Open Domes Large': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_OPEN_DOMES_LARGE
  },
  'Open Domes Medium': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_OPEN_DOMES_MEDIUM
  },
  'Open Domes Small': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_OPEN_DOMES_SMALL
  },
  'Closed Domes Large': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_CLOSED_DOMES_LARGE
  },
  'Closed Domes Medium': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_CLOSED_DOMES_MEDIUM
  },
  'Closed Domes Small': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_CLOSED_DOMES_SMALL
  },
  'Double Domes Large': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_DOUBLE_DOMES_LARGE
  },
  'Double Domes Medium': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_DOUBLE_DOMES_MEDIUM
  },
  'Double Domes Small': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_DOUBLE_DOMES_SMALL
  },
  'Wax Guard': {
    full: process.env.NEXT_PUBLIC_PRODUCT_SKU_WAX_GUARD
  }
}

const productInfo = {
  'Orka One': {
    multipleOptions: true,
    options: {
      full: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 1180,
        currency: '',
        unit: 'Per Pair',
        shipping: 0,

        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        // shippingPromise: 'Nov 21',
        // arrivalPromise: 'Friday, Dec 2',
        quantityDisplay: false,
        services: ['3-year warranty', '45-day money back guarantee'],
        img: '/imgs/checkout/product.png',
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              {i18n.t(k.WE_RE_PREPPING_YOUR_HEARING_AI1)}
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka One Journey',
        nextText: `We\'re prepping your hearing aids to ensure you enjoy a personsalized hearing experience. We\'ll let you know when they\'re on their way! (Won\'t be long!) ${ZWSP}Your 45-day free trial will start the day after Orka hearing aids are delivered.${ZWSP}`
      },
      monthly: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 75,
        currency: '/mo.',
        unit: 'for 18 months',
        note: `Paid monthly by Orka Monthly Installments starting ${moment().format(
          'MMM D, YYYY'
        )}`,
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: false,
        services: ['3-year warranty', '45-day money back guarantee'],
        img: '/imgs/checkout/product.png',
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              {i18n.t(k.WE_RE_PREPPING_YOUR_HEARING_AI1)}
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka One Journey',
        nextText: `We\'re prepping your hearing aids to ensure you enjoy a personsalized hearing experience. We\'ll let you know when they\'re on their way! (Won\'t be long!) ${ZWSP}Your 45-day free trial will start the day after Orka hearing aids are delivered.${ZWSP}`
      }
    }
  },
  'Orka One Old': {
    multipleOptions: true,
    options: {
      full: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 1050,
        currency: '',
        unit: 'Per Pair',
        shipping: 0,

        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        // shippingPromise: 'Nov 21',
        // arrivalPromise: 'Friday, Dec 2',
        quantityDisplay: false,
        services: ['3-year warranty', '45-day money back guarantee'],
        img: '/imgs/checkout/product.png',
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              {i18n.t(k.WE_RE_PREPPING_YOUR_HEARING_AI1)}
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka One Journey',
        nextText: `We\'re prepping your hearing aids to ensure you enjoy a personsalized hearing experience. We\'ll let you know when they\'re on their way! (Won\'t be long!) ${ZWSP}Your 45-day free trial will start the day after Orka hearing aids are delivered.${ZWSP}`
      },
      monthly: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 75,
        currency: '/mo.',
        unit: 'for 12 months',
        note: `Paid monthly by Orka Monthly Installments starting ${moment().format(
          'MMM D, YYYY'
        )}`,
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: false,
        services: ['3-year warranty', '45-day money back guarantee'],
        img: '/imgs/checkout/product.png',
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              {i18n.t(k.WE_RE_PREPPING_YOUR_HEARING_AI1)}
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka One Journey',
        nextText: `We\'re prepping your hearing aids to ensure you enjoy a personsalized hearing experience. We\'ll let you know when they\'re on their way! (Won\'t be long!) ${ZWSP}Your 45-day free trial will start the day after Orka hearing aids are delivered.${ZWSP}`
      }
    }
  },

  'Orka Insider Program Pay': {
    multipleOptions: true,
    options: {
      full: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 1180,
        currency: '',
        unit: 'Per Pair',
        shipping: 0,
        coupon: true,
        services: ['3-year warranty'],
        img: '/imgs/checkout/product.png',
        succeedTitle: 'Payment Completed!',
        succeedText: (
          <Typography variant="subh2" style={{ marginTop: '12px' }}>
            {i18n.t(k.THANK_YOU_FOR_COMPLETING_THE_O)}

            <br />
            {i18n.t(k.PLEASE_REMEMBER_THAT_ORKA_SUPP)}
          </Typography>
        )
      },
      monthly: {
        coupon: true,
        name: 'Orka One AI Hearing Aids',
        price: 75,
        currency: '/mo.',
        unit: 'for 18 months',
        note: `Paid monthly by Orka Monthly Installments starting ${moment().format(
          'MMM D, YYYY'
        )}`,
        shipping: 0,
        coupon: true,
        services: ['3-year warranty'],
        img: '/imgs/checkout/product.png',
        succeedTitle: 'Payment Completed!',
        succeedText: (
          <Typography variant="subh2" style={{ marginTop: '12px' }}>
            {i18n.t(k.THANK_YOU_FOR_COMPLETING_THE_O)}

            <br />
            {i18n.t(k.PLEASE_REMEMBER_THAT_ORKA_SUPP)}
          </Typography>
        )
      }
    }
  },
  'Open Domes': {
    multipleOptions: false,
    options: {
      full: {
        coupon: true,
        name: 'Open Domes',
        price: 15,
        currency: '',
        unit: 'Per Set (3 Pairs)',
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: true,
        img: {
          Large:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/large-open+domes-01.jpg',
          Medium:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/medium-open+domes-01.jpg',
          Small:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/open/small-open+domes-01.jpg'
        },
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              We're prepping your accessories, and we will let you know when
              they're on their way. (Not too long from now!)
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka Journey',
        nextText:
          "Your accessories have been arranged for shipment. We will let you know when they are on the way (won't be long)."
      }
    }
  },
  'Closed Domes': {
    multipleOptions: false,
    options: {
      full: {
        coupon: true,
        name: 'Closed Domes',
        price: 15,
        currency: '',
        unit: 'Per Set (3 Pairs)',
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: true,
        img: {
          Large:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/large-closed+domes-01.jpg',
          Medium:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/medium-closed+domes-01.jpg',
          Small:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/closed/small-closed+domes-01.jpg'
        },
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              We're prepping your accessories, and we will let you know when
              they're on their way. (Not too long from now!)
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka Journey',
        nextText:
          "Your accessories have been arranged for shipment. We will let you know when they are on the way (won't be long)."
      }
    }
  },
  'Double Domes': {
    multipleOptions: false,
    options: {
      full: {
        coupon: true,
        name: 'Double Domes',
        price: 15,
        currency: '',
        unit: 'Per Set (3 Pairs)',
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: true,
        img: {
          Large:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/large-double+domes-01.jpg',
          Medium:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/medium-double+domes-01.jpg',
          Small:
            'https://legacy-cdn.hiorka.com/imgs/accessories/domes/double/small-double+domes-01.jpg'
        },
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              We're prepping your accessories, and we will let you know when
              they're on their way. (Not too long from now!)
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka Journey',
        nextText:
          "Your accessories have been arranged for shipment. We will let you know when they are on the way (won't be long)."
      }
    }
  },
  'Wax Guard': {
    multipleOptions: false,
    options: {
      full: {
        coupon: true,
        name: 'Wax Guard',
        price: 10,
        currency: '',
        unit: 'Per Set (3 Pairs)',
        shipping: 0,
        shippingPromise: moment().businessAdd(5).format('MMM D'),
        arrivalPromise: moment().businessAdd(12).format('dddd, MMM D'),
        quantityDisplay: true,
        img: 'https://legacy-cdn.hiorka.com/imgs/accessories/maintenance+tools/wax+guard/brushes-01.jpg',
        succeedText: (
          <Typography variant="subh2" sx={{ color: theme.palette.grey[700] }}>
            {i18n.t(k.NOTE)} &nbsp;
            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
              We're prepping your accessories, and we will let you know when
              they're on their way. (Not too long from now!)
            </Typography>
          </Typography>
        ),
        nextJourney: 'Orka Journey',
        nextText:
          "Your accessories have been arranged for shipment. We will let you know when they are on the way (won't be long)."
      }
    }
  }
}

export { skuMap, productInfo, reviseNextText }
